<template>
  <div>

    <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular">Verify Password
                <v-spacer/>
                <v-btn v-if="moduleName === 'dashboard'" icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
                <v-btn v-if="moduleName !== 'dashboard'" icon @click="$router.go(-1)"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Password</label>
                            <v-text-field autofocus outlined v-model="password" class="mt-3" validate-on-blur autocomplete="new-password"
                                          :type="showPassword?'text':'password'" @click:append="showPassword = !showPassword" @keydown.enter="verifyPassword"
                                          :append-icon="showPassword?'mdi-eye':'mdi-eye-off'" :rules="[v => !!v || 'Password Required']"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn v-if="moduleName === 'dashboard'" outlined class="text-capitalize mr-2" @click="closeDialog()">Cancel</v-btn>
                <v-btn v-if="moduleName !== 'dashboard'" outlined class="text-capitalize mr-2" @click="$router.go(-1)">Cancel</v-btn>
                <v-btn outlined class="primary px-3 text-capitalize" dark @click="verifyPassword">Verify</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Snackbar :toaster="toaster"/>
  </div>
</template>

<script>
import Constants from "../../Constants/Constants";
import Snackbar from "../../components/Common/Snackbar";

export default {
    name: "VerifyPasswordPopup",
    components: {Snackbar},
    props: {
        dialog: {
        type: Boolean
        },
        moduleName: {
        type: String,
        default: null
        }
    },
    data(){
        return{
            password: '',
            showPassword: false,
            toaster: {enable: false}
        }
    },
    methods:{
        verifyPassword(){
            if(!this.password) this.toaster = {enable:true, color:'red', message: 'Please enter Password !'};
            else if(this.password === Constants.SecurityModulePassword) this.updateDialog(); 
            else this.toaster = {enable:true, color:'red', message: 'Invalid Password entered !'}
        },
        closeDialog() {
            this.password = '';
            this.$emit('change:dialog', false);
        },
        updateDialog() {
            this.password = '';
            this.$emit('update:dialog', false);
        }
    }
}
</script>

<style scoped>

</style>